import React from 'react';
import PropTypes from 'prop-types';
import { Column, Row } from 'hedron';
import DesignerListLink from './DesignerListLink';
import withCountryCode from '../RoutesHoc/RoutesHoc';

const DesignerListDesignersColumn = ({ designers, buildUrlWithCountry }) => (
  <div>
    {designers.map((designer, innerIndex) => (
      <Row key={innerIndex}>
        <Column fluid>
          <DesignerListLink alias={designer.alias} name={designer.name} url={buildUrlWithCountry(designer.url)} />
        </Column>
      </Row>
    ))}
  </div>
);

DesignerListLink.propTypes = {
  designers: PropTypes.arrayOf(
    PropTypes.shape({
      alias: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  buildUrlWithCountry: PropTypes.func.isRequired,
};

export default withCountryCode(DesignerListDesignersColumn);
